<template>
  <div>
    <v-dialog v-model="claim_details_dialog" width="500" persistent>
      <v-card
        style="position: relative; padding-bottom: 20px"
        min-height="250"
        width="500"
      >
        <v-toolbar flat>
          <v-toolbar-title style="font-weight: bold"
            >Claim Status</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon color="grey" dark @click="cancel_claim_details_dialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div
          class="ma-5 overflow-y-auto"
          style="text-align: left; max-height: 450px"
        >
          <div>
            <p style="font-weight: bold">Status:</p>
            <div style="margin-top: -10px">
              <v-autocomplete
                style="margin-bottom: 15px"
                v-model="claim_status"
                :items="['pending', 'claimed']"
                single-line
                hide-details="auto"
                outlined
                single
                dense
              ></v-autocomplete>
            </div>
          </div>
        </div>
        <v-card-actions>
          <!-- <v-spacer></v-spacer> -->
          <v-btn
            color="primary"
            class="white--text"
            block
            depressed
            style="text-transform: capitalize"
            @click="update_claim_status"
            :loading="is_submitting"
            :disabled="is_submitting"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
      style="margin-top: 25px"
    >
      <h2>Claim Log Management</h2>
    </div>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <v-divider></v-divider>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
    >
      <v-card outlined>
        <v-data-table
          :headers="headers"
          :items="commission_log_list"
          :loading="table_loading"
          loading-text="Loading... Please wait"
          :mobile-breakpoint="0"
          :search="search"
          @click:row="view_claim"
        >
          <!-- @click:row="view_machine" -->
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search Log"
                  single-line
                  hide-details
                  color="primary"
                ></v-text-field>
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      selected_claim_doc_id: "",
      claim_status: "",
      claim_details_dialog: false,
      is_submitting: false,
      headers: [
        {
          text: "Username",
          value: "username",
          sortable: true,
          divider: true,
        },
        {
          text: "Company Name",
          value: "company_name",
          sortable: true,
          divider: true,
        },
        {
          text: "Claim Date Time",
          value: "action_time",
          sortable: false,
          divider: true,
        },
        {
          text: "Claim Amount",
          value: "claim_amount",
          sortable: false,
          divider: true,
        },
        {
          text: "Status",
          value: "status",
          sortable: true,
          divider: false,
        },
      ],
      commission_log_list: [],
      table_loading: false,
      search: "",
      current_user_permission: [],
      current_user_company_doc_id: "",
    };
  },
  methods: {
    cancel_claim_details_dialog() {
      this.claim_details_dialog = false;
      this.claim_status = "";
      this.selected_claim_doc_id = "";
    },
    async update_claim_status() {
      this.is_submitting = true;
      const response = (
        await this.send_http_request("updateClaimStatus", {
          claim_doc_id: this.selected_claim_doc_id,
          claim_status: this.claim_status,
        })
      ).data;
      this.is_submitting = false;
      this.cancel_claim_details_dialog();
      if (response.status == "OK") {
        this.show_snack_bar("success", "Status updated");
        this.load_commission_log();
      } else {
        this.show_snack_bar("error", "Something went wrong");
      }
    },
    view_claim(claim) {
      this.claim_status = claim.status;
      this.selected_claim_doc_id = claim.claim_doc_id;
      this.claim_details_dialog = true;
    },
    load_commission_log() {
      this.table_loading = true;
      this.send_http_request("getAllCommissionLogWithCompanyID", {
        company_doc_id: this.current_user_company_doc_id,
      })
        .then((response) => {
          this.table_loading = false;
          if (response.data.status == "OK") {
            this.commission_log_list = response.data.result;
            this.commission_log_list.sort((a, b) =>
              a.raw_action_time > b.raw_action_time ? -1 : 1
            );
          }
        })
        .catch((error) => {
          this.table_loading = false;
          console.log(error);
        });
    },
  },
  mounted() {
    this.load_commission_log();
  },
  created() {
    this.current_user_permission = this.$store.getters.getUserRoleList;
    this.current_user_company_doc_id = this.$store.getters.getUserCompanyDocId;
    if (this.current_user_company_doc_id != "") {
      if (
        !this.current_user_permission.includes("qHeDHIMwA3UD02cPqw0G") &&
        !this.current_user_permission.includes("UsVr0wHOjW29JiLaIv0E")
      ) {
        this.$router.push({ name: "HomeScreen" }).catch((err) => {});
      }
    }
    // Update store
    var payload = {
      headerType: "needHeader",
      currentPage: "CommissionLogScreen",
    };
    this.$store.dispatch("updateHeaderType", payload);
    this.$store.dispatch("updateCurrentPage", payload);
  },
  computed: {
    generalSpacingLeftRight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 5;
        case "sm":
          return 5;
        case "md":
          return 3;
        case "lg":
          return 3;
        case "xl":
          return 3;
        default:
          return 5;
      }
    },
  },
};
</script>

<style>
</style>